/**
 * Prefix on every fingerprint this module builds, so a custom-grouped issue
 * can be told apart from a default-grouped one in Datadog.
 */
export const NO_FIRST_PARTY_FRAME_FINGERPRINT_PREFIX = "no-first-party-frame";

/**
 * Messages the Datadog Browser SDK builds for an unhandled rejection whose
 * reason says nothing: `"Empty reason"` is the SDK's own placeholder for a
 * falsy reason (`Promise.reject()`, `reject(undefined)`), and `{}` is a
 * plain object with no fields. With no stack, no type and no text, there is
 * nothing to group on, so a fingerprint just opens an untitled issue that
 * pages. Before the fingerprint existed these never formed an issue.
 */
export const CONTENT_FREE_REJECTION_MESSAGE_PATTERN =
  /^Uncaught (?:"Empty reason"|\{\})$/;

/**
 * `error.source` the Datadog Browser SDK sets on errors it reports about
 * itself (rate limits, upload queue limits), not about the page.
 */
export const DATADOG_SDK_ERROR_SOURCE = "agent";

/** Used when an error event carries no type/kind. */
export const DEFAULT_ERROR_TYPE = "Error";

/** Long messages are cut so one runaway string can't make a huge key. */
export const MAX_NORMALIZED_MESSAGE_LENGTH = 200;

/**
 * A frame URL pointing at a Next.js static chunk, capturing its origin
 * (absent for a relative path). Paired with the host check below, this is
 * the signal that our own bundle is on the stack.
 */
export const FIRST_PARTY_CHUNK_URL_PATTERN =
  /(?:^|[\s(@])(https?:\/\/[^/\s()]+)?\/_next\/static\//;

/** Our production and preview hosts, plus local dev. */
export const FIRST_PARTY_HOST_PATTERN =
  /^(?:[\w-]+\.)*marblehealth\.com$|^localhost$|^127\.0\.0\.1$/;
